import { createModel } from '@/store/tools';

const model = {
    namespace: 'riderlevelset',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getRatingRules': T('getRatingRules'),
            'getLevelList': T('getLevelList'),
            'getLevelInfo': T('getLevelInfo'),
        },
        actions: {
            'getRatingRules': A('getRatingRules'),
            'getLevelList': A('getLevelList'),
            'getLevelInfo': A('getLevelInfo'),
        },
        sagas: {
            'getRatingRules': S('getRatingRules', '/?cmd=com.xqxc.api.pig.mis.biz.rules.LevelScoreRuleService.levelScoreRule'),
            'getLevelList': S('getLevelList', '/?cmd=com.xqxc.api.pig.mis.biz.account.AcRiderLevelMisService.list'),
            'getLevelInfo': S('getLevelInfo', '/?cmd=com.xqxc.api.pig.mis.biz.account.AcRiderLevelMisService.detail'),
        },
        reducers: {
            'ratingRules': R('getRatingRules', { finishOrderScore: {}, firstFinishOrderScore: {}, inviteRiderScore: {}, dayIniviteRiderLimit: {}, dayScoreLimit: {} ,convertRatio:{}}),
            'levelList': R('getLevelList', []),
            'levelInfo': R('getLevelInfo', {}),
        }
    })
};
export default createModel(model);